//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
import { Check, Visibility    } from '@mui/icons-material';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
//  -- Thunks -------------------------
import { handleBatchGradeSubmissions, handleUpdateGrade } from 'store/submissions/thunks';
import { Description } from '@mui/icons-material';
import styled from 'styled-components';
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';

import { handleListClassSubmissions } from 'store/submissions/thunks';
import { find, map ,get  } from 'lodash'
import { handleUpdateGoolgeGradeInBatch } from 'store/googleClassRoom/thunks';
import {  handleUpdateCanvasGradeInBatch, handleUpdateCanvasStatus } from 'store/canvas/thunks';
import { handleGradeToSchoology } from 'store/schoology/thunks';
import * as Sentry from '@sentry/react';




//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Button = styled.button`
    align-items: center;
    background-color: ${COLOR.green100};
    border: none;
    border-radius: 2px;
    color: white;
    cursor: pointer;
    display: flex;
    height: 24px;
    margin-left: 4px;
    justify-content: center;
    opacity: 0;
    outline: none;
    padding: 2px;
    transition: all 300ms ease;
    width: 24px;

    &:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    }
`;

const Input = styled.input`
    border: 1px solid;
    border-radius: 3px;
    box-shadow: none;
    font-size: inherit;
    outline: none;
    padding: 0px 4px;
    transition: all 300ms ease;
    text-align:center;
    width: 60px;
`;

const Form = styled.form`
    algin-items: center;
    color: ${p => p.graded ? 'inherit' : 'red'};
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 100%;

    &:hover ${Input} {
        border: 1px solid ${p => p.disabled ? 'white' : 'white'};
    }

    &:hover ${Button} {
        opacity: ${p => p.disabled ? 0 : 1};
        color: white;
    }
`;
const CheckBox = styled.div`
    align-items: center;
    height: 24px;
    display: flex;
    justify-content: center;
    width: 24px;
    margin-left: 4px;
    margin-right: 4px;
    cursor: pointer;
    transition: all 300ms ease;
    `;
const MenuItem = styled.div`
    display: flex;
    flex-direction: row;
    `;
const TbgArea = styled.div`
    position: absolute;
    bottom: -12px;
    font-size: 8px;
    color:${COLOR.black}
`;
const MaxPointText = styled.span`
    color:${COLOR.gray100};
    align-content: center;
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Grade editing form
//
//  -- Description
//  Allows editing of grades/submissions
//
//  -- Props
//  ...
//
//  -- State
//  ...
//

const hasGradeInA_F = (val) => {
    if (typeof val === "string") {
        const hasInGrade =  [{key:'A',value:90},{key:'B',value:70},{key:'C',value:50},{key:'D',value:30},{key:'F',value:10}].find(k => k.key.toLowerCase() === val.toLowerCase())
        if (hasInGrade) {
            return ({
                value: hasInGrade.value,
                hasValue: true
            })
        }
        return ({
            value: val,
            hasValue: false
        })
    } else {
        return ({
            value: val,
            hasValue: false
        })
    }

}


const GradeEditor = React.forwardRef(({
    assignmentId,
    data,
    reviewAssignment,
    submission,
    userId,
    value,
    isReviewAccount,
    disabled,
    scale_1_5,
    gradebook_a_f,
    tempData,
    assignment,
    user,
    currentClass,
    assignments,
    studentSubmissions,
    assignemnt,
    onFlagMenuViewChange,
    isTbg,
    handleGradeValueShow,
    ungraded,
    currentUser,
    face_grade,
    enterKeyListner,
    onFocus,
    onBlur
}, ref) => {
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const [tempValue, setTempValue] = useState(value);
    const [tempFlag, setTempFlag] = useState(submission?.exceptionStatus || 0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const is_update = useRef(false);
    
    useImperativeHandle(ref, () => {
        const input = document.getElementById(assignmentId + userId);
        return {
            focus: () => {
                editValue()
            },
            blur: () => {
                if (inputRef.current) {
                    inputRef.current.blur();
                }
            },
            isFocused: () => {
                return input === document.activeElement;
            },
            ref: inputRef.current || input
        };
    });
    const grade_type = assignment?.grade_type;
    const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
    const isPointSystem =  grade_type === "points"
    const editValue = () => {
        const input = document.getElementById(assignmentId + userId);
        if(input){
            input.focus();
            input.select();
        }
    };
    const setVal = () =>{
        const input = document.getElementById(assignmentId + userId);
        const is_this_active = input === document.activeElement;
        if (is_this_active) return;
        if (isPointSystem && !gradebook_a_f) {
            const val = ((typeof face_grade == "number" && face_grade >= 0) || (typeof face_grade == "string" && face_grade >= 0)) ? face_grade : null;
            setTempValue(val);
        } else {
            setTempValue(value);
        }
        setTempFlag(submission?.exceptionStatus || 0);
    }

    useEffect(() => {
        setVal()
    }, [value, submission, assignment, face_grade, gradebook_a_f])
    const handleChange = (e) => {
        e.preventDefault();
        let _value = e.target.value.replace(/-/g, "");
        if (_value.startsWith('0') && _value.length > 1) {
            setTempValue('0');
            return;
        }
        const af =  hasGradeInA_F(_value)
        const isAf = af.hasValue && !!gradebook_a_f;
        const isScale = scale_1_5 && _value <= 4 && _value >= 0
        const isAv = !scale_1_5 && !gradebook_a_f && _value <= 100 && _value >= 0
        if (isPointSystem) {
            if (typeof max_point === "number") {
                if (_value >= 0 && _value <= max_point) {
                    setTempValue(_value);
                }
            } else {
                if (_value >= 0 && _value <= 100) {
                    setTempValue(_value);
                }
            }
        }else if (isScale ||isAf || isAv || _value === "") {
            setTempValue(_value);
        }        
    };
    const updateGradetoSchoology = async(_val, statusCode) => {
        if (currentClass && currentClass.sectionId && user && user.schoologyid) {
            await handleGradeToSchoology({
                sectionId: currentClass?.sectionId,
                schoologyid: currentUser.schoologyid,
                statusCode: statusCode,
                value: _val,
                studentSchoologyIds: [user.schoologyid],
                sAssignmentId: assignment?.sAssignmentId
            })
        }
    }
    const updateGradetoGoogleClassRoom = async(_val) => {
        if (currentClass && currentClass.googleId && user && user.googleId) {
            try {
              await handleUpdateGoolgeGradeInBatch(currentUser.googleId,user.googleId,currentClass.googleId,assignments.googleId,_val)
            } catch (error) {
                Sentry.captureException(`590 Error in updateGradetoGoogleClassRoom: ${error}`);
                console.log(error, "issue in update grade to classroom");
            }
        }
    }
    const updateGradeToCanvas = async (_val, status) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id && assignments?.canvas_id) {
            if (status>=0) {
                await handleUpdateCanvasStatus(currentUser.canvas_id,{
                    "canvas_assignment_id":assignments.canvas_id,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":user.canvas_id,
                    "status": status
                },currentUser.canvas_auth_id)
            } else {
                await handleUpdateCanvasGradeInBatch(currentUser.canvas_id,{
                    "canvas_assignment_id": assignments?.canvas_id,
                    "course_id":currentClass.canvas_course_id,
                    "canvas_user_id":user.canvas_id,
                    "grade": _val
                },currentUser.canvas_auth_id)
            }
        }
        }
    const submit = async (e , on_force_update) => {
        e.preventDefault();
        e.stopPropagation();
        if (onBlur) onBlur();
        let _val = tempValue;
        const hasInA_F = hasGradeInA_F(tempValue)
        if(isPointSystem){
            if(!on_force_update &&((tempValue === face_grade && !isTbg)||tempValue ==="-")){
                if (is_update.current) {
                    is_update.current = false;
                }
                return;
            }
             if(!on_force_update && !(tempValue>=0&&tempValue<=max_point)){
                if (is_update.current) {
                    is_update.current = false;
                }
                return;
             }
        }
        if (!on_force_update && (
            (tempValue === value || tempValue === "-") ||
            (!gradebook_a_f && isNaN(tempValue)) ||
            (scale_1_5 && tempValue > 4) ||
            (gradebook_a_f && !hasInA_F.hasValue) ||
            (!scale_1_5 && !gradebook_a_f && tempValue > 100)
        )) {
            if (is_update.current) {
                is_update.current = false;
            }
            setTempValue(value);
            return;
        }

        if (scale_1_5 && tempValue <= 4) {
            _val = tempValue==0?tempValue:`${(tempValue*20)+10}`
        }
        if (gradebook_a_f && hasInA_F.hasValue) {
            _val = hasInA_F.value
        }
        if(isPointSystem){
            const per = (tempValue / max_point ) * 100;
            _val=per;
        }
        tempData.grade = _val;
        tempData.graded = true;
        tempData.manualGrading = false;
        tempData.submissions = 1
        tempData.face_grade = tempValue
        is_update.current = true;
        updateGradetoSchoology(isPointSystem ? tempValue : _val);
        updateGradeToCanvas(isPointSystem ? tempValue : _val)
        updateGradetoGoogleClassRoom(isPointSystem ? tempValue : _val);
        if (assignemnt?.assignments?.length > 0) {
            let avggrade = _val / (assignemnt.assignments.length + 1);
            let tempDataArray = []
            let _data = {
                answers: data?.answers,
                complete: data?.complete,
                grade: avggrade,
                submissions: data?.submissions,
                retaking: data?.retaking || false,
                graded: true,
                feedback: data?.feedback || '',
                manualGrading: false,
            }
            tempData.grade = avggrade;
            let allSubmissions = assignments.assignments.map((_assignemnt, i) => {
                let sub = find(studentSubmissions, ['assignmentId', _assignemnt?.data?.id]);
                if (sub) {
                    return ({
                        answers: sub?.answers,
                        complete: sub?.complete,
                        grade: avggrade,
                        submissions: sub?.submissions,
                        retaking: sub?.retaking || false,
                        graded: true,
                        feedback: sub?.feedback || '',
                        manualGrading: false,
                        id: sub?.id,
                    })
                } else {
                    let _assignmentinfo = _assignemnt.data ?? _assignemnt ?? {};
                    let quizdata = { ...tempData }
                    quizdata.grade = avggrade;
                    quizdata.assignment = _assignmentinfo;
                    quizdata.assignmentId = _assignmentinfo.id;
                    quizdata.chapter = _assignmentinfo.chapter;
                    quizdata.bookId = _assignmentinfo.bookId
                    quizdata.retakes = _assignemnt.retakes;
                    tempDataArray[i] = quizdata;
                    return null
                }
            })
            Promise.all(map(allSubmissions, async subm => {
                if (subm) {
                    const dt = {
                        id: subm.id,
                        grade: subm.grade,
                        face_grade: tempValue
                    }
                    await dispatch(handleBatchGradeSubmissions(dt));
                }
            })).then(() => {
                Promise.all(map(tempDataArray, async subm => {
                    if (subm) {
                        let dt = {
                            grade: subm.grade, 
                            face_grade: tempValue,
                            assignmentId: subm.assignmentId,
                            assignmentType: subm.assignmentType,
                            chapter: subm.chapter,
                            classId: subm.classId,
                            orgId: currentUser.orgId,
                            userId: subm.userId,
                        }
                        await dispatch(handleBatchGradeSubmissions(dt));
                    }
                })).then(async () => {
                    if (get(submission, "id")) {
                        const dt = {
                            id: submission.id,
                            grade: _data.grade,
                            face_grade: tempValue
                        }
                        await dispatch(handleBatchGradeSubmissions(dt));
                    } else {
                        let dt = {
                            grade: _data.grade, 
                            face_grade: tempValue,
                            assignmentId: tempData.assignmentId,
                            assignmentType: tempData.assignmentType,
                            chapter: tempData.chapter,
                            classId: tempData.classId,
                            orgId: currentUser.orgId,
                            userId: tempData.userId,
                        }
                        await dispatch(handleBatchGradeSubmissions(dt));
                    }
                })
            })

        } else {
            if(get(submission,"id")){
                const dt = {
                    id: submission.id,
                    grade: _val,
                    face_grade: tempValue
                }
                await dispatch(handleBatchGradeSubmissions(dt))
            } else {
                let dt = {
                    grade: _val, 
                    face_grade: tempValue,
                    assignmentId: tempData.assignmentId,
                    assignmentType: tempData.assignmentType,
                    chapter: tempData.chapter,
                    classId: tempData.classId,
                    orgId: currentUser.orgId,
                    userId: tempData.userId,
                }
                await dispatch(handleBatchGradeSubmissions(dt))
            }
        }
    };
    const updateStatus = async (status) => {
        tempData.grade = status == 3 ? 0 : null;
        tempData.graded = true;
        tempData.exceptionStatus = status;
        tempData.submissions = 1
        if(get(submission,"id")){
            const dt = {
                id:submission.id,
                grade: status == 3 ? 0 : null,
                exceptionStatus : status
            }
            await dispatch(handleUpdateGrade(dt))
        } else {
            let dt = {
                grade: status == 3 ? 0 : null, 
                face_grade: status == 3 ? 0 : null,
                assignmentId: tempData.assignmentId,
                assignmentType: tempData.assignmentType,
                chapter: tempData.chapter,
                classId: tempData.classId,
                orgId: currentUser.orgId,
                userId: tempData.userId,
            }
            await dispatch(handleBatchGradeSubmissions(dt))
        }
        await dispatch(handleListClassSubmissions(tempData.classId));
        // if(!submission?.id){
        //     await dispatch(handleListClassSubmissions(tempData.classId));
        // }
    }


    const graded = () => {
        if (submission?.retaking) {
            return true;
        } else if (submission?.complete && submission?.graded) {
            return true;
        } else if (!submission) {
            return true;
        } else {
            return false;
        }
    }
    const updateStatusCode = (status) => {
        menuVisibalityChange(false);
        const _status = tempFlag == status ? 0 : status;
        updateStatus(_status)
        setTempFlag(_status);
        updateGradetoSchoology(status == 3 ? 0 : null, _status)
    }
    const getCheckIcon = (status) => {
        if (tempFlag == status) {
            return <Check style={{ color: COLOR.green100, fontSize: 15 }} />
        } else {
            return null;
        }
    }
    const menuVisibalityChange = (visiblity) => {
        setIsMenuOpen(visiblity);
        onFlagMenuViewChange(visiblity)
    }
  
    const isDisable = value === '--' || isReviewAccount || disabled || value === '--' || tempFlag > 0 || ungraded;
    const getReviewSubmission = () => {
        return submission && Object.keys(submission).length > 0 ? submission : tempData
    }
    const getValue = () => {
        if (ungraded) return "-";
        else if (tempFlag == 0 || !tempFlag) {
            if (tempValue === null || tempValue === "NULL") {
                return '-';
            }
            return (typeof tempValue === "number" && tempValue >= 0) || (typeof tempValue === "string") ? tempValue : '-';
        } else if (tempFlag == 3) {
            if (gradebook_a_f) return 'F';
            return '0';
        } else {
            return "--";
        }
    }
    return (
        <Form
            disabled={disabled&&tempFlag<=0}
            className={disabled && tempFlag <= 0 ? 'gradeFormDisable' : ''}
            onSubmit={e => {
                e.preventDefault();
                e.stopPropagation();

                const input = document.getElementById(assignmentId + userId);
                input.blur();
            }}
            graded={graded()}
        >
            <Button className="buttonPdf" onClick={e => e.preventDefault()} disabled={disabled && tempFlag <= 0} style={{ marginRight: 5 }}>
                <Description onClick={() => { handleGradeValueShow({ ...assignment, user, submissionData: { value, submission: data } }); }} />
            </Button> 
            
            <Input
                disabled={isDisable}
                id={assignmentId + userId}
                ref={inputRef}
                onBlur={(e) => {
                    if (onBlur) onBlur();
                    if (e.target.value === '' || e.target.value === null || e.target.value === '-' || e.target.value ==='--') {
                        e.target.value = getValue()
                        setVal()
                        return;
                    }
                    const originalValue = isPointSystem && !gradebook_a_f ? face_grade : value;
                    if (e.target.value != originalValue && e.target.value !== '-' && e.target.value !== '--') {
                        submit(e)
                    } else {
                        is_update.current = false;
                    }
                }}
                onClick={editValue}
                onChange={handleChange}
                onFocus={(e) => {
                    if (e.target.value === '-') {
                        e.target.value = '';
                    }
                    e.target.select();
                    if (onFocus) onFocus(e);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
                        e.preventDefault();
                        if (typeof enterKeyListner === "function") enterKeyListner()
                        if(!(e.target.value === ''||e.target.value === '-' || e.target.value ==='--')){
                            submit(e);
                        }    
                    }
                }}
                value={getValue()}
                style={{ color: 'black' }}
            />
            {isPointSystem?<MaxPointText>{`/${max_point}`}</MaxPointText>:null}
            <Button disabled={disabled&&tempFlag<=0} onClick={() => reviewAssignment(getReviewSubmission())} type="button">
                <Visibility style={{ fontSize: '16px' }} />
            </Button>
           {isTbg&&<TbgArea>TBG - AI</TbgArea>}
        </Form>
    );
});


GradeEditor.displayName = 'GradeEditor';

export default GradeEditor;
